import axios from "axios";
import React, { useEffect } from "react";
import GetServerAddress from "../../../../../functions/GetServerAddress";

export function Get_Hubspot_Contact_By_ID_Alert(HubspotContactID, logout) {
  const fetchData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() + "api/staff/Get_Hubspot_Contact_By_ID",
        {
          HubspotContactID: HubspotContactID,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Username"),
            activitylog: "No",
          },
        }
      );
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logout();
        return; // Stop further execution in case of invalid auth token
      }
      console.log("Response Data: ");
      console.log(response.data.data.properties.jobtitle);
      let Properties = response.data.data.properties || null;
      let JobTitle = Properties.jobtitle || null;
      let JobFunction = Properties.job_function || null;
      let JobTitleString =
        "Job Title: " +
        (JobTitle ? JobTitle.toString() : "No Job Title Found") +
        "\n" +
        "Job Function: " +
        (JobFunction ? JobFunction.toString() : "No Job Function Found");
      window.alert(JobTitleString); // Update your state with the fetched data
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  fetchData();
} // Empty dependency array means this effect runs only once
